import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { Form, Input, Spin } from "antd";
import { useFormService, useI18n } from "../../../../../contexts";
import { FormValueDifferFromTemplateTag } from "../../..";
import { slugify } from "@devowl-wp/react-utils";
const FormServiceFieldGeneralName = ()=>{
    const { __ } = useI18n();
    const { hasServiceByUniqueName } = useFormService();
    const [ref, setRef] = useState();
    const [hover, setHover] = useState(false);
    const [uniqueNameValidating, setUniqueNameValidating] = useState(false);
    const validateUniqueName = useCallback(async (slug, overwrite)=>{
        setUniqueNameValidating(true);
        try {
            const found = slug ? await hasServiceByUniqueName(slug) : false;
            if (found) {
                if (!overwrite) {
                    throw __("A service with the same unique name already exists.");
                } else {
                    // Consent Forwarding is deactivated, so we need to generate an unique name for the user
                    const matchRegexp = /^(.*)-(\d+)$/;
                    let uniqueName = slug;
                    let foundGenerated = found;
                    while(foundGenerated){
                        uniqueName = uniqueName.match(matchRegexp) ? uniqueName.replace(matchRegexp, (_, g1, g2)=>`${g1}-${+g2 + 1}`) : `${uniqueName}-1`;
                        foundGenerated = await hasServiceByUniqueName(uniqueName);
                    }
                    // Overwrite in form
                    overwrite(uniqueName);
                }
            }
        } finally{
            setUniqueNameValidating(false);
        }
    }, [
        hasServiceByUniqueName
    ]);
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Name"),
        required: true,
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "name",
                noStyle: true,
                rules: [
                    {
                        required: true,
                        message: __("Please provide a name!")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Input, {})
            }),
            /*#__PURE__*/ _jsx(Spin, {
                spinning: uniqueNameValidating,
                children: /*#__PURE__*/ _jsx("div", {
                    onMouseEnter: ()=>setHover(true),
                    onMouseLeave: ()=>setHover(false),
                    style: {
                        marginTop: "-1px",
                        opacity: hover ? 1 : 0.7,
                        transition: "opacity 200ms"
                    },
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        shouldUpdate: (prevValues, nextValues)=>prevValues.name !== nextValues.name,
                        children: (param)=>{
                            let { getFieldValue, setFieldsValue } = param;
                            const name = getFieldValue("name");
                            const nameSlug = slugify(name);
                            return /*#__PURE__*/ _jsx(Form.Item, {
                                name: "uniqueName",
                                noStyle: true,
                                validateTrigger: "onBlur",
                                rules: [
                                    {
                                        validator: async (rules, value)=>validateUniqueName(value, (uniqueName)=>setFieldsValue({
                                                    uniqueName
                                                }))
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Input, {
                                    addonBefore: __("Unique identifier"),
                                    placeholder: nameSlug,
                                    size: "small"
                                })
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "description",
                ref: setRef,
                children: [
                    /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                        form: "service",
                        valueName: "name",
                        widthOfRef: ref,
                        renderDiff: (value)=>/*#__PURE__*/ _jsx(Input, {
                                value: value,
                                readOnly: true
                            })
                    }),
                    __('Each service used should have a descriptive name that is understandable to a non-professional user. Example: "Google Analytics". In addition, each service must have a unique identifier that you use for e.g. consent forwarding or the developer API (automatically generated if empty).')
                ]
            })
        ]
    });
};
export { FormServiceFieldGeneralName };
